import { TypeParallaxWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import Parallax, { ParallaxProps } from './Parallax'

const ContentfulParallax = withContentful<TypeParallaxWithoutUnresolvableLinksResponse['fields'], ParallaxProps>(
  Parallax,
  {
    sections: (props) => {
      return props.fields.parallaxSections.map((section) => ({
        leftChild: <BlockRenderer block={section.fields?.leftChild} />,
        rightChild: <BlockRenderer block={section.fields?.rightChild} />,
      }))
    },
    reverseColumns: (props) => props.fields.reverseColumns,
    isSingleColumn: (props) => props.fields.singleColumnSection,
  }
)

export default ContentfulParallax
